<template>
  <div class="search-component">
    <div class="search-result-index">
      <div class="searched-info">
        <label v-if="$route.params.query">
          Search for
          <span class="keyword">{{ $route.params.query | validate }}</span>
        </label>
        <span class="display-count">Displaying
          {{ getSearchedConsultants.length | validate }} results</span>
      </div>

      <div class="pagination" v-if="getSearchedConsultants.length > 0">
        <label>1 - {{ getSearchedConsultants.length | validate }} of
          {{ getSearchedConsultants.length | validate }} results</label>
        <ul class>
          <li class="page-number" v-for="page in 1" :key="page + 'jsk'">
            {{ page | validate }}
          </li>
          <li class="page-btn-prev">
            <img src="@/assets/icons/prev_gray.svg" alt />
          </li>
          <li class="page-btn-next">
            <!-- <img src="@/assets/icons/search_next.svg" alt />
            -->
            <img src="@/assets/icons/next_gray.svg" alt />
          </li>
        </ul>
      </div>
    </div>
    <div class="search-widget">
      <div class="search-wrapper">
        <div class="phone-open-filter">
          <label v-if="getSearchedConsultants.length > 0">
            Displaying
            <span>{{ getSearchedConsultants.length | validate }}</span> results
          </label>
          <button class="filter-btn" @click.prevent="toggleFilter()">
            Filters
          </button>
        </div>
        <div class="search-container">
          <div class="search-body" v-if="getSearchedConsultants.length > 0">
            <ul class="search-items">
              <template v-for="(item, index) in getSearchedConsultants">
                <li class="search-result" :key="index + 'search'" v-if="item.user_id !== userId" @click="
                  (e) => {
                    gotoProfile(item);
                  }
                ">
                  <div class="search-item-logo">
                    <img v-if="item.profile" :src="$fullUrl('images/profiles/' + item.profile)" />
                    <img v-else src="../../assets/avatar.png" />
                  </div>
                  <div class="search-item-content">
                    <div class="item-content-header">
                      <strong class="title">{{ item.names | validate }}</strong>
                      <span class="type" v-if="item.type == 1">Consultant</span>
                      <span class="type" v-else-if="item.type == 2">Customer</span>
                    </div>
                    <span class="content">{{ item.job | validate }}</span>
                    <label class="location">{{
                      item.location | validate
                    }}</label>
                  </div>
                </li>
              </template>
            </ul>
          </div>
          <div class="search-body" v-else>
            <div class="no-search-data">
              <h5>No Result Found</h5>
              <p>We can’t find any matching item of your search</p>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-widget" :class="{ show: toggle_filter }">
        <div class="filter-ribbon">
          <button @click.prevent="toggleFilter()">
            <img src="@/assets/icons/close__ic.svg" alt />
            Close
          </button>
          <label>Search</label>
        </div>

        <div class="title-widget" style="
              margin-bottom: 11px;
              border-bottom: 1px solid rgb(204, 204, 204);
              padding-bottom: 11px;
            ">
          <span>FILTERS</span>
          <button class="reset-btn" @click="searchByAll">Reset</button>
        </div>
        <div class="skills-widget">
          <div class="skill-container">
            <div class="skill-container-title">
              <span>Skills</span>
            </div>
            <div class="skill-container-form">
              <div class="input-group">
                <input type="text" v-model="search.skill" @keyup="searchSuggetion()" @focus="skillCompletesuggest = true"
                  @blur="closeSuggetion" placeholder="Type skill here…" />
                <img src="@/assets/icons/cicle-add-icon.svg" @click="
                  () => {
                    if (
                      search.skill &&
                      !checkIfExist(search.skills, search.skill)
                    ) {
                      search.skills.push(search.skill);
                      search.skill = '';
                    }
                  }
                " alt />
              </div>

              <div class="suggested-items active" v-if="search.skills.length > 0">
                <span class="item active" v-for="(item, i) in search.skills" @click="
                  () => {
                    search.skills.splice(i, 1);
                  }
                " :key="item">{{ item | validate }}</span>
              </div>
              <div class="line" v-if="skillCompletesuggest && search.skill"></div>
              <div class="suggested-items" v-if="skillCompletesuggest && search.skill">
                <span class="item" v-for="item in suggestion" :key="item" @click="
                  () => {
                    if (!checkIfExist(search.skills, item)) {
                      search.skills.push(item);
                      search.skill = '';
                    }
                  }
                ">{{ item | validate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="title-widget">
          <span>Availability</span>
          <div class="available-now">
            <input type="checkbox" name id="avnow" v-model="search.available_now" />
            <label for="avnow"></label> Available now
          </div>
        </div>
        <div class="availability-widget">
          <div class="search-range-date">
            <datepicker :monday-first="true" placeholder="From" :disabled-dates="{ to: new Date() }"
              input-class="date-field-input" wrapper-class="date-field" v-model="search.from"></datepicker>
            <datepicker :monday-first="true" :disabled="search.available_now" v-model="search.to" placeholder="To"
              input-class="date-field-input" wrapper-class="date-field"></datepicker>
          </div>
        </div>
        <div class="divider"></div>
        <div class="title-widget">
          <span>Location</span>
        </div>
        <div class="location-widget">
          <select v-model="search.country" @change="
            (e) => {
              $store.dispatch('GET_CITIES', { country: e.target.value });
            }
          ">
            <option :value="0">Country</option>
            <template v-for="(country, index) in getCountries.countries">
              <option :value="country.id" :key="index + 'shjs'">
                {{ country.name | validate }}
              </option>
            </template>
          </select>
          <select v-model="search.city">
            <option :value="0">City</option>
            <template v-for="(city, index) in getCities">
              <option :value="city.id" :key="index + 'djdjs'">
                {{ city.name | validate }}
              </option>
            </template>
          </select>
        </div>
        <div class="divider"></div>
        <div class="company-widget">
          <div class="company-container">
            <div class="company-container-title">
              <span>Company</span>
            </div>
            <div class="company-container-form">
              <div class="input-group">
                <input type="text" v-model="search.company" placeholder="Type company here…"
                  @focus="companyCompletesuggest = true" @blur="closeSuggetion" />
                <img src="@/assets/icons/cicle-add-icon.svg" @click="
                  () => {
                    if (
                      search.company &&
                      !checkIfExist(search.companies, search.company)
                    ) {
                      search.companies.push(search.company);
                      search.company = '';
                    }
                  }
                " alt />
              </div>

              <div class="suggested-items active" v-if="search.companies.length > 0">
                <span class="item active" v-for="(item, i) in search.companies" @click="
                  () => {
                    search.companies.splice(i, 1);
                  }
                " :key="item">{{ item | validate }}</span>
              </div>
              <div class="line" v-if="companyCompletesuggest && search.company"></div>
              <div class="suggested-items" v-if="companyCompletesuggest && search.company">
                <span class="item" v-for="(item, index) in company_suggested" @click="
                  () => {
                    if (!checkIfExist(search.companies, item)) {
                      search.companies.push(item);
                      search.company = '';
                    }
                  }
                " :key="index + 'ddusik'">{{ item | validate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="view-all-btn">
          <button @click="searchByAllFilter">Apply filters</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
export default {
  name: "search",
  props: {},
  computed: {
    ...mapGetters([
      "getCountries",
      "getCities",
      "getSearchedConsultants",
      "getMeProfile",
      "getSkillsData",
    ]),
    userId() {
      return this.getMeProfile.user.id;
    },
    suggestion() {
      let skills = [];
      console.log("hdh", this.getSkillsData);
      this.getSkillsData.tools.forEach((item, index) => {
        skills.push(item);
      });
      this.getSkillsData.domains.forEach((item, index) => {
        skills.push(item);
      });
      this.getSkillsData.competences.forEach((item, index) => {
        skills.push(item);
      });
      this.getSkillsData.roles.forEach((item, index) => {
        skills.push(item);
      });
      this.getSkillsData.languages.forEach((item, index) => {
        skills.push(item);
      });
      return skills;
    },
  },
  components: {
    Datepicker,
  },
  data: () => {
    return {
      skillCompletesuggest: false,
      companyCompletesuggest: false,
      company_suggested: ["Meritios", "Google Inc", "IBM", "Tesla", "Toyota"],
      available_now: false,
      isActive: 0,
      items: [],
      toggle_filter: false,
      paginate: ["getSearchedConsultants"],
      search: {
        q: "",
        skill: "",
        skills: [],
        from: "",
        to: "",
        available_now: false,
        country: 0,
        city: 0,
        company: "",
        companies: [],
      },
    };
  },
  mounted() {
    this.$store.dispatch("GET_SKILLS_BY_TYPE", { type: "tools" });
    this.$store.dispatch("GET_SKILLS_BY_TYPE", { type: "domains" });
    this.$store.dispatch("GET_SKILLS_BY_TYPE", { type: "competences" });
    this.$store.dispatch("GET_SKILLS_BY_TYPE", { type: "roles" });
    this.$store.dispatch("GET_SKILLS_BY_TYPE", { type: "languages" });
    this.$store.dispatch("GET_COUNTRIES");
    this.search.q = this.$route.params.query;
  },
  methods: {
    moment,
    searchSuggetion() {
      let vm = this;
      vm.getSuggetion(vm.search.skill, "tools");
      vm.getSuggetion(vm.search.skill, "domains");
      vm.getSuggetion(vm.search.skill, "competences");
      vm.getSuggetion(vm.search.skill, "roles");
      vm.getSuggetion(vm.search.skill, "languages");
    },
    getSuggetion(keyword, type) {
      // Hook suggest search api
      let vm = this;
      vm.$store.dispatch("SEARCH_SKILLS", { name: keyword, type: type });
    },
    gotoProfile(item) {
      if (item.type == 1)
        this.$router.push({
          name: "profile-view",
          params: { id: item.user_id },
        });
      else if (item.type == 2)
        this.$router.push({
          name: "profile_customer",
          params: { id: item.user_id },
        });
    },
    toggleFilter() {
      let vm = this;
      vm.toggle_filter = !vm.toggle_filter;
    },
    searchByAll(e) {
      this.search = {
        skill: "",
        skills: [],
        from: "",
        to: "",
        available_now: false,
        country: 0,
        city: 0,
        company: "",
        companies: [],
      };
      this.$store.dispatch("SEARCH_INDEX", { q: this.$route.params.query });
      this.toggleFilter();
    },
    searchByAllFilter() {
      this.search.from = moment(this.search.from).format("YYYY-MM-DD");
      // let q = "+names:*" + this.$route.params.query + "*";

      // if (this.search.location !== "")
      //   q = q + " +location:*" + this.search.location + "*";

      // if (this.search.job !== "") q = q + " +job:*" + this.search.job + "*";

      // if (this.search.skill !== "")
      //   q = q + " +skills:*" + this.search.skill + "*";
      // if (this.search.from !== "")
      //   q = q + " +available_from:{" + this.search.from + " TO *}";
      // console.log(q);

      this.$store.dispatch("SEARCH_BY_ALL", this.search);
      this.toggleFilter();
    },
    searchByLocation(e) {
      this.isActive = 1;
      this.$store.dispatch("SEARCH_BY_LOCATION", {
        q: e,
        names: this.$route.params.query,
      });
      this.toggleFilter();
    },
    searchBySkills(e) {
      this.isActive = 1;
      this.$store.dispatch("SEARCH_BY_COMPANY", { q: e });
    },
    searchByCompany(e) {
      this.isActive = 1;
      this.$store.dispatch("SEARCH_BY_SKILLS", { q: e });
      this.toggleFilter();
    },
    setSelected(date) {
      try {
        this.search.from = new Date(date).toISOString().slice(0, 10);
        console.log(this.search.from);
        this.searchBy();
      } catch (e) {
        console.log(e);
      }
    },
    closeSuggetion() {
      setTimeout(() => {
        this.skillCompletesuggest = false;
        this.companyCompletesuggest = false;
      }, 500);
    },
    checkIfExist(array, val) {
      let exist = false;
      if (val) {
        array.forEach((item) => {
          if (item.toLowerCase() === val.toLowerCase()) {
            exist = true;
          }
        });
        return exist;
      } else {
        return true;
      }
    },
  },
  watch: {
    $route(to, from) {
      this.$store.dispatch("SEARCH_INDEX", { q: this.$route.params.query });
    },
  },
};
</script>
<style lang="scss" scoped>
.search-component {
  display: block;

  .search-result-index {
    @media (min-width: 300px) and (max-width: 630px) {
      display: none;
    }

    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .searched-info {
      margin-top: 15px;
      margin-bottom: 15px;

      label {
        font-weight: 800;
        display: block;
        margin-bottom: 10px;

        .keyword {
          color: #999999;
        }
      }

      .display-count {
        font-style: italic;
      }
    }

    .pagination {
      display: flex;
      align-items: center;

      ul {
        list-style: none;
        display: flex;
        align-items: center;

        li {
          margin-left: 10px;
        }

        li.page-number {
          height: 20px;
          width: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #2090ba;
          border-radius: 50%;
          font-size: 10px;
        }
      }
    }
  }

  .search-widget {
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 10px;

    @media (min-width: 300px) and (max-width: 630px) {
      grid-template-columns: auto;
      grid-column-gap: 0px;
    }

    .search-wrapper {
      background: #ffffff 0% 0% no-repeat padding-box;
      border-radius: 5px;
      padding: 20px 20px 0 20px;
      width: 480px;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        box-shadow: 0px 0px 0px #fff;
        border-radius: 0px;
      }

      .phone-open-filter {
        display: none;

        @media (min-width: 300px) and (max-width: 630px) {
          display: flex;
          justify-content: space-between;
          padding: 0px;
          align-items: center;

          label {
            color: #999999;
            font-style: italic;
          }

          .filter-btn {
            border: 1px solid #278fb8;
            border-radius: 5px;
            padding: 6px 30px;
            background: #fff;
            color: #278fb8;
            font-weight: 800;
          }
        }
      }

      .search-container {
        background: #fff 0% 0% no-repeat padding-box;
        border-radius: 5px;

        .search-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .search-options {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #fff;

            .filter-btn {
              padding: 7px 2px 7px 25px;
              background-image: url("../../assets/icons/grey__search__icon.svg");
              background-color: #efefef;
              background-size: 13px;
              background-position: 7px 9px;
              color: #7c7c7c;
              font-size: 14px;
              border: none;

              width: 22%;
              border-radius: 5px;
              outline: none;
            }

            .all-filter-btn {
              font-size: 14px;
              outline: none;
              color: #00a5a6;
              background: transparent;
              border: none;
              border-left: 1px solid #ccc;
              padding: 10px 20px;
              width: 10%;

              cursor: pointer;
            }
          }
        }

        .search-body {
          padding: 8px;

          ul.search-items {
            margin-left: -38px;
            list-style: none;

            .search-item {
              margin-bottom: 8px;
              border-bottom: 2px solid #f5f5f5;

              span {
                color: #707070;
              }
            }

            .search-result {
              display: flex;
              align-items: center;
              justify-content: space-between;
              background: #fff;
              padding: 5px;
              cursor: pointer;
              padding-left: 0px;
              margin-bottom: 7px;
              border-bottom: 2px solid #f5f5f5;

              .search-item-logo {
                margin-right: 10px;

                img {
                  width: 40px;
                  height: 40px;
                  border-radius: 100%;
                  object-fit: cover;
                }
              }

              .search-item-content {
                width: 100%;

                .item-content-header {
                  display: flex;
                  justify-content: space-between;

                  .title {
                    font-size: 13px !important;
                    color: #0884af;
                  }

                  .type {
                    color: #b3b3b3 !important;

                    font-size: 12px;
                  }
                }

                .content {
                  color: #4e4e4e;

                  display: block;
                }

                .location {
                  color: #b3b3b3;

                  font-size: 12px;
                }
              }
            }
          }

          .no-search-data {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 40px 100px;

            h5 {
              font-size: 16px;
              font-family: "Nunito", sans-serif;
              color: #000000;
              font-weight: 800;
              text-align: center;
              margin-bottom: 20px;
            }

            p {
              color: #999999;
              font-size: 14;
              text-align: center;
            }
          }
        }
      }
    }

    .filter-widget.show {
      @media (min-width: 300px) and (max-width: 630px) {
        left: 0px;
        transition: 400ms ease-in;
      }
    }

    .filter-widget {
      width: 300px;
      padding: 15px 15px;
      background: #ffffff 0% 0% no-repeat padding-box;
      border-radius: 5px;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        position: fixed;
        padding: 10px 10px;
        background: #fff;
        z-index: 99999999999;
        top: 0px;
        left: 630px;
        right: 0px;
        bottom: 0;
        overflow-y: auto;
        padding-top: 56px;
        transition: 400ms ease-in;
      }

      .filter-ribbon {
        background: transparent linear-gradient(90deg,
            #1ba5a4 0%,
            #1aa3a4 2%,
            #1992a9 31%,
            #1888ac 62%,
            #1885ad 100%) 0% 0% no-repeat padding-box;
        position: absolute;
        left: 0px;
        right: 0px;
        top: 0px;
        padding: 16px 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        button {
          color: #fff;
        }

        label {
          color: #fff;
        }
      }

      .view-all-btn {
        width: 100%;
        display: flex;
        margin-top: 20px;
        justify-content: center;

        button {
          background: #2f91b6 0% 0% no-repeat padding-box;
          border-radius: 5px;
          color: #fff;
          outline: none;
          border: none;
          padding: 10px 20px;
          width: 60%;
        }
      }

      .title-widget {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        span {
          font-size: 16px;
          color: #707070;
        }

        .reset-btn {
          border: 1px solid #2090ba;
          border-radius: 2px;
          color: #2090ba;
          padding: 4px 29px;
          outline: none;
        }

        .apply-btn {
          width: 77px;
          height: 20px;
          outline: none;
          background: #2f91b6 0% 0% no-repeat padding-box;
          border-radius: 5px;
          color: #fff;
          border: none;

          &:disabled {
            background: #bcbcbc 0% 0% no-repeat padding-box;
          }
        }

        .apply-btn.active {
          width: 77px;
          height: 20px;
          background: #2f91b6 0% 0% no-repeat padding-box;
          border-radius: 5px;
          color: #fff;
          border: none;
        }
      }

      .skills-widget,
      .company-widget {
        background: #fff;

        .company-container {
          display: grid;
          grid-template-columns: 70px calc(100% - 70px);

          .company-container-title {}

          .company-container-form {
            width: 100%;

            .input-group {
              border: 1px solid #2090ba;
              background: #fff;
              border-radius: 5px;
              display: flex;
              align-items: center;
              padding-right: 10px;

              input {
                height: 39px;
                border-radius: 5px;
                width: 100%;
                padding: 0px 10px;
                outline: none;
              }

              img {
                width: 25px;
              }
            }

            .line {
              width: 100%;
              border-bottom: 1px solid #ccc;
              margin-top: 5px;
              margin-bottom: 5px;
            }

            .suggested-items {
              display: flex;
              flex-wrap: wrap;
              max-height: 130px;
              overflow-y: auto;
              background: #e6e6e6;
              padding: 8px;
              border-radius: 5px;

              .item {
                height: 25px;
                background: #b2b2b2 0% 0% no-repeat padding-box;
                border-radius: 13px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                color: #fff;
                padding: 0px 10px;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 800;
                margin-right: 10px;
                margin-bottom: 10px;
                cursor: pointer;
              }

              .item.active {
                background: #0884af !important;
              }
            }

            .suggested-items.active {
              background: #fff !important;
              padding: 10px 0px !important;
            }
          }
        }

        .skill-container {
          display: grid;
          grid-template-columns: 42px calc(100% - 42px);

          .skill-container-title {}

          .skill-container-form {
            width: 100%;

            .input-group {
              border: 1px solid #2090ba;
              background: #fff;
              border-radius: 5px;
              display: flex;
              align-items: center;
              padding-right: 10px;

              input {
                height: 39px;
                width: 100%;
                padding: 0px 10px;
                outline: none;
              }

              img {
                width: 25px;
              }

              input:focus {}
            }

            .line {
              width: 100%;
              border-bottom: 1px solid #ccc;
              margin-top: 5px;
              margin-bottom: 5px;
            }

            .suggested-items {
              display: flex;
              flex-wrap: wrap;
              max-height: 130px;
              overflow-y: auto;
              background: #e6e6e6 0% 0% no-repeat padding-box;
              padding: 8px;
              border-radius: 5px;

              .item {
                height: 25px;
                background: #b2b2b2 0% 0% no-repeat padding-box;
                border-radius: 13px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                color: #fff;
                padding: 0px 10px;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 800;
                margin-right: 10px;
                margin-bottom: 10px;
                cursor: pointer;
              }

              .item.active {
                background: #0884af !important;
              }
            }

            .suggested-items.active {
              background: #fff !important;
              padding: 10px 0px !important;
            }
          }
        }
      }

      .divider {
        width: 100%;
        border-bottom: 1px solid#E2E2E2;
        margin-top: 25px;
        margin-bottom: 15px;
      }

      .availability-widget {
        .available-now {
          display: flex;

          label {
            position: relative;
            top: 1px;
            margin-left: 6px;
          }
        }

        .search-range-date {
          display: grid;
          grid-column-gap: 10px;
          grid-template-columns: 48% 48%;

          .date-field {
            height: 39px;
            background: #fff;
            border-radius: 5px;
            padding: 10px 10px;
            border-radius: 5px;
            border: 1px solid #c7c7c7;
            margin-left: 0px;
          }
        }
      }

      .location-widget {
        display: grid;
        grid-template-columns: 48% 48%;
        grid-column-gap: 10px;

        select {
          height: 39px;
          background: #fff;
          border-radius: 5px;
          padding: 0px 10px;
          outline: none;
          border: 1px solid #c7c7c7;
        }
      }
    }
  }
}
</style>
